import { loadScript, loadCSS } from 'utils/index';
import { processEnv } from 'utils/config';

const h5_fe_lib =
  processEnv.hostEnv == 'online'
    ? '//h5cdn.babytreeimg.com'
    : '//h5cdn-1.babytree-test.com';

export function lazyWTA() {
  if (window.WTA) {
    return Promise.resolve(window.WTA);
  } 
  return loadScript(`${h5_fe_lib}/h5_fe_lib/release/w2a/1.4.1/index.min.js`, {
    attrs: { crossorigin: 'anonymous' }
  }).then(() => {
    return window.WTA;
  });
  
}

export function lazyWLA() {
  if (window.WLA) {
    return Promise.resolve(window.WLA);
  } 
  return loadScript(
    `${h5_fe_lib}/h5_fe_lib/release/wla/0.0.17/index.min.js`,
    {
      attrs: { crossorigin: 'anonymous' }
    }
  ).then(() => {
    return window.WLA;
  });
  
}

/**
 * 修复 monitor@2.0.6：unhandledrejection 的 reason 为空时直接读 .message 会抛
 * TypeError: Cannot read properties of undefined (reading 'message')
 */
function patchBbtMonitor(monitor) {
  if (!monitor || monitor.__patchedEmptyRejection) return monitor;
  monitor.__patchedEmptyRejection = true;
  monitor.errorEvent = function () {
    const self = this;
    window.addEventListener(
      'error',
      function (t) {
        const n = {};
        const r = t.target;
        if (r && r.nodeName) {
          n.msg = r.nodeName.toLowerCase() + '标签资源加载失败';
          n.filename = r.src || r.href || '';
        } else {
          n.msg = t.message || '';
          n.filename = t.filename || '';
          n.row = t.lineno || '';
          n.column = t.colno || '';
          n.stack = t.error && t.error.stack ? t.error.stack : '';
        }
        self.sendError(n);
      },
      true
    );
    window.addEventListener(
      'unhandledrejection',
      function (t) {
        const reason = t.reason;
        if (reason == null) {
          self.sendError({ msg: 'unhandledrejection', stack: '' });
          return;
        }
        if (typeof reason === 'string') {
          self.sendError({ msg: reason, stack: '' });
          return;
        }
        self.sendError({
          msg: reason.message || 'unhandledrejection',
          stack: reason.stack || ''
        });
      },
      true
    );
  };
  return monitor;
}

export function lazyMonitor() {
  if (window.bbtMonitor) {
    return Promise.resolve(patchBbtMonitor(window.bbtMonitor));
  } 
  return loadScript(
    `${h5_fe_lib}/h5_fe_lib/release/monitor/2.0.6/index.min.js?data=20230324`,
    {
      attrs: { crossorigin: 'anonymous' }
    }
  ).then(() => {
    return patchBbtMonitor(window.bbtMonitor);
  });
  
}

export function lazySwiper() {
  if (window.Swiper) {
    return Promise.resolve(window.Swiper);
  } 
  return loadScript(`${h5_fe_lib}/h5_fe_lib/libs/swiper.min.js`, {
    attrs: { crossorigin: 'anonymous' }
  }).then(() => {
    return window.Swiper;
  });
  
}

export function lazyBBTVideoPlayer() {
  if (window.bbtVideoPlayer) {
    return Promise.resolve(window.bbtVideoPlayer);
  } 
  loadCSS(
    `${h5_fe_lib}/h5_fe_lib/release/bbt-video-player/0.0.1/index.min.css`
  );
  return loadScript(
    `${h5_fe_lib}/h5_fe_lib/release/bbt-video-player/0.0.1/index.js`,
    {
      attrs: { crossorigin: 'anonymous' }
    }
  ).then(() => {
    return window.bbtVideoPlayer;
  });
  
}

// APM监控
export function lazyBrowserClient() {
  // if (window.browserClient) {
  //   return Promise.resolve(window.browserClient);
  // }
  // return new Promise((resolve, reject) => {
  //   import('@apmplus/web').then(browserClient => {
  //     window.browserClient = browserClient.default;
  //     resolve(browserClient.default);
  //   }).catch(() => reject());
  // });
  
}
export function lazyWeixinJsSdk() {
  if (window.wx) {
    return Promise.resolve(window.wx);
  } 
  return loadScript(`//res.wx.qq.com/open/js/jweixin-1.6.0.js`, {
  }).then(() => {
    return window.wx;
  });
  
}
